import { useRef } from 'react'

export const useChanges = (value, callback) => {
  const cache = useRef(value)
  if (cache.current !== value) {
    callback(value, cache.current)
    cache.current = value
  }
}
